// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__1JB17","wrapperMaxWidth":"Layout_wrapperMaxWidth__1X11h"};